import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    FunctionField,
    DateField,
    BooleanField,
    EditButton,
    ShowButton,
    Filter,
    SearchInput,
} from 'react-admin';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    DateInput,
    ReferenceInput,
} from 'react-admin';
import {
    Show,
    SimpleShowLayout,
} from 'react-admin';

const SalesRepFilter = () => (
    <Filter>
        <SearchInput source="company_name" alwaysOn />
        <SearchInput source="employee_id" />
        <SearchInput source="territory" />
    </Filter>
);

export const SalesRepList = () => (
    <List filters={<SalesRepFilter />}>
        <Datagrid>
            <TextField source="id" />
            <FunctionField source="user_uuid" label="Email" render={(record: any) => record?.user_email || ''} />
            <TextField source="employee_id" />
            <TextField source="company_name" />
            <TextField source="territory" />
            <TextField source="state" />
            <TextField source="city" />
            <BooleanField source="is_active" />
            <DateField source="created_at" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export const SalesRepEdit = () => (
    <Edit>
        <SimpleForm>
            <ReferenceInput source="user_uuid" reference="users" />
            <TextInput source="employee_id" />
            <TextInput source="company_name" />
            <TextInput source="company_website" />
            <TextInput source="phone_number" />
            <TextInput source="territory" />
            <TextInput source="state" />
            <TextInput source="city" />
            <TextInput source="services_offered" multiline rows={3} />
            <TextInput source="experience_years" />
            <TextInput source="certifications" multiline rows={3} />
            <TextInput source="bio" multiline rows={4} />
            <TextInput source="profile_image" />
            <TextInput source="commission_rate" />
            <DateInput source="hire_date" />
            <BooleanInput source="is_active" />
            <TextInput source="notes" multiline rows={3} />
        </SimpleForm>
    </Edit>
);

export const SalesRepShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <FunctionField source="user_uuid" label="Email" render={(record: any) => record?.user_email || ''} />
            <TextField source="employee_id" />
            <TextField source="company_name" />
            <TextField source="company_website" />
            <TextField source="phone_number" />
            <TextField source="territory" />
            <TextField source="state" />
            <TextField source="city" />
            <TextField source="services_offered" />
            <TextField source="experience_years" />
            <TextField source="certifications" />
            <TextField source="bio" />
            <TextField source="profile_image" />
            <TextField source="commission_rate" />
            <DateField source="hire_date" />
            <BooleanField source="is_active" />
            <TextField source="notes" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
); 